export default __webpack_public_path__ + "static/media/DryerLogo.23e6568d.png";